module.exports = __webpack_public_path__ + "img/xuzhou.11c80f9b.png";